export const OPERATION_AUTHZ = {
    'Query.accountingSyncStatus': {
        requires: ['integrations.accounting.see_status'],
    },
    'Query.achReturn': { requires: ['get_paid.invoices.view'] },
    'Query.achVendorReturn': { requires: ['bill_pay.bills.view'] },
    'Query.adminNickelBalanceAccounts': { ungated: 'staff' },
    'Query.adminPennyChats': { ungated: 'staff' },
    'Query.adminPennyConversation': { ungated: 'staff' },
    'Query.answerForms': { requires: ['get_paid.invoices.view'] },
    'Query.apiFile': { ungated: 'signed-in' },
    'Query.apiTokens': { requires: ['developers.api.manage_tokens'] },
    'Query.approvalRuleSummaries': { ungated: 'no-catalog-key' },
    'Query.approvalRules': { requires: ['approvals.workflows.manage'] },
    'Query.approvals': { ungated: 'no-catalog-key' },
    'Query.authorizationRecordLookup': { ungated: 'staff' },
    'Query.bankRoutingNumber': { ungated: 'public' },
    'Query.bill': { requires: ['bill_pay.bills.view'] },
    'Query.billPayable': { requires: ['bill_pay.bills.view'] },
    'Query.billPayables': { requires: ['bill_pay.bills.view'] },
    'Query.billPayment': { requires: ['bill_pay.bills.view'] },
    'Query.bills': { requires: ['bill_pay.bills.view'] },
    'Query.billsById': { requires: ['bill_pay.bills.view'] },
    'Query.chargeback': { requires: ['get_paid.invoices.view'] },
    'Query.chargebacks': { requires: ['transactions.chargebacks.respond'] },
    'Query.chartOfAccounts': {
        requires: ['integrations.accounting.see_chart_of_accounts'],
    },
    'Query.checkApproval': { ungated: 'no-catalog-key' },
    'Query.checkApprovals': { ungated: 'no-catalog-key' },
    'Query.checkCustomDomainAvailability': { ungated: 'no-catalog-key' },
    'Query.clientAccess': { requires: ['team_org.team.manage_roles'] },
    'Query.conductorAuthenticate': {
        requires: ['integrations.accounting.connect_qbd'],
    },
    'Query.connectorCatalog': { ungated: 'no-catalog-key' },
    'Query.connectorConnections': {
        requires: ['penny.connectors.use_workspace'],
        silent: true,
    },
    'Query.connectorRead': { requires: ['penny.connectors.use_workspace'] },
    'Query.customDomainVerificationStatus': { ungated: 'no-catalog-key' },
    'Query.debitAuthorization': { requires: ['get_paid.customers.view'] },
    'Query.enterpriseSsoConfig': { ungated: 'no-catalog-key', silent: true },
    'Query.enterpriseSsoForEmail': { ungated: 'public' },
    'Query.entriToken': { ungated: 'no-catalog-key' },
    'Query.existingUserFromEmail': { ungated: 'public' },
    'Query.firmClients': { ungated: 'no-catalog-key' },
    'Query.followUpCallOffer': { ungated: 'no-catalog-key' },
    'Query.getAllMerchantPaymentMethods': { ungated: 'no-catalog-key' },
    'Query.getAllPaymentMethods': { ungated: 'public' },
    'Query.getClientToken': { ungated: 'capability' },
    'Query.getDebitAuthorizationFromShortId': { ungated: 'public' },
    'Query.getPaymentMethod': { ungated: 'no-catalog-key' },
    'Query.getPaymentRequest': { ungated: 'public' },
    'Query.getQuickBooksClasses': {
        requires: ['integrations.accounting.see_chart_of_accounts'],
    },
    'Query.getQuickBooksDepartments': {
        requires: ['integrations.accounting.see_chart_of_accounts'],
    },
    'Query.getQuickBooksExpenseAccountsAndItems': {
        requires: ['integrations.accounting.see_chart_of_accounts'],
    },
    'Query.getQuickBooksRevenueAccountsAndItems': {
        requires: ['integrations.accounting.see_chart_of_accounts'],
    },
    'Query.hubspotDealStatuses': { ungated: 'staff' },
    'Query.inboundBankTransfers': { requires: ['get_paid.invoices.view'] },
    'Query.integrationConnectionStatus': {
        requires: ['integrations.accounting.see_status'],
    },
    'Query.invoiceApprovalRequests': { ungated: 'no-catalog-key' },
    'Query.mcpActionApproval': { ungated: 'no-catalog-key' },
    'Query.mcpActionApprovalSummary': { ungated: 'no-catalog-key' },
    'Query.mcpActionApprovals': { ungated: 'no-catalog-key' },
    'Query.nickelBalanceAccounts': {
        requires: ['banking.account.see_balance'],
        silent: true,
    },
    'Query.nickelBalanceAvailableHistory': {
        requires: ['banking.account.see_balance'],
        silent: true,
    },
    'Query.nickelBalanceCard': {
        requires: ['banking.cards.see'],
        silent: true,
    },
    'Query.nickelBalanceCards': {
        requires: ['banking.cards.see'],
        silent: true,
    },
    'Query.nickelBalanceCheckDeposit': {
        requires: ['banking.account.see_deposits'],
        silent: true,
    },
    'Query.nickelBalanceCheckDeposits': {
        requires: ['banking.account.see_deposits'],
        silent: true,
    },
    'Query.nickelBalanceDebitAllowRules': {
        requires: ['banking.account.see_balance'],
        silent: true,
    },
    'Query.nickelBalanceDebitOriginators': {
        requires: ['banking.account.see_balance'],
        silent: true,
    },
    'Query.nickelBalanceDepositInstructions': {
        requires: ['banking.account.see_deposit_instructions'],
        silent: true,
    },
    'Query.nickelBalanceFundingSources': {
        requires: ['banking.account.see_linked_accounts'],
        silent: true,
    },
    'Query.nickelBalanceInboundCheckReviews': {
        requires: ['banking.account.see_balance'],
        silent: true,
    },
    'Query.nickelBalanceInboundDebitReviews': {
        requires: ['banking.account.see_balance'],
        silent: true,
    },
    'Query.nickelBalanceInstantPayout': {
        requires: ['bill_pay.bills.pay'],
        silent: true,
    },
    'Query.nickelBalanceInterestSummary': {
        requires: ['banking.account.see_balance'],
        silent: true,
    },
    'Query.nickelBalanceOnboardingReadiness': {
        requires: ['banking.account.apply'],
        silent: true,
    },
    'Query.nickelBalancePayoutOffers': {
        requires: ['bill_pay.bills.pay'],
        silent: true,
    },
    'Query.nickelBalanceStatements': {
        requires: ['banking.account.see_statements'],
        silent: true,
    },
    'Query.nickelBalanceWireCheck': {
        requires: ['bill_pay.bills.pay'],
        silent: true,
    },
    'Query.notificationEmailRecipients': {
        requires: ['team_org.organization.manage_notifications'],
    },
    'Query.oauthAuthorizationRequest': { ungated: 'signed-in' },
    'Query.onboardingInfo': { ungated: 'staff' },
    'Query.organization': { ungated: 'signed-in' },
    'Query.organizationPage': { ungated: 'public' },
    'Query.organizationPages': { ungated: 'staff' },
    'Query.organizations': { ungated: 'staff' },
    'Query.organizationsForAdmin': { ungated: 'staff' },
    'Query.partner': { ungated: 'capability' },
    'Query.partnerAccount': { ungated: 'capability' },
    'Query.partnerAccounts': { ungated: 'capability' },
    'Query.partnerEnrollment': { ungated: 'capability' },
    'Query.partnerEnrollmentSession': { ungated: 'capability' },
    'Query.partnerEnrollments': { ungated: 'capability' },
    'Query.payment': { requires: ['get_paid.invoices.view'] },
    'Query.paymentActivities': {
        ungated: 'carve-out',
        argumentRequires: {
            source: ['banking.account.see_balance'],
            nickelBalanceOnly: ['banking.account.see_balance'],
            nickelBalanceAccountId: ['banking.account.see_balance'],
            issuedCardId: ['banking.account.see_balance', 'banking.cards.see'],
        },
    },
    'Query.paymentActivity': { ungated: 'no-catalog-key', silent: true },
    'Query.paymentHistory': { ungated: 'no-catalog-key' },
    'Query.paymentMethodRequests': { requires: ['get_paid.customers.view'] },
    'Query.paymentsSummary': { ungated: 'no-catalog-key' },
    'Query.payout': { requires: ['transactions.activity.see_payouts'] },
    'Query.payoutMethods': { ungated: 'no-catalog-key', silent: true },
    'Query.payouts': { requires: ['transactions.activity.see_payouts'] },
    'Query.pennyActiveWebVisit': { ungated: 'no-catalog-key' },
    'Query.pennyConversation': { ungated: 'no-catalog-key' },
    'Query.pennyConversations': { ungated: 'no-catalog-key', silent: true },
    'Query.pennyPendingChatCount': { ungated: 'no-catalog-key', silent: true },
    'Query.platformPartnerForAdmin': { ungated: 'staff' },
    'Query.platformPartnersForAdmin': { ungated: 'staff' },
    'Query.questionForm': {
        requires: ['get_paid.invoices.view'],
        silent: true,
    },
    'Query.questionForms': { requires: ['get_paid.invoices.view'] },
    'Query.questionFormsById': { requires: ['get_paid.invoices.view'] },
    'Query.quickBooksUnderwrite': { ungated: 'staff' },
    'Query.quickbooksAuthenticate': {
        requires: ['integrations.accounting.connect_qbo'],
        silent: true,
    },
    'Query.receipt': { ungated: 'public' },
    'Query.recurringBill': { requires: ['bill_pay.bills.view'] },
    'Query.recurringBills': { requires: ['bill_pay.bills.view'] },
    'Query.recurringInvoice': { requires: ['get_paid.invoices.view'] },
    'Query.recurringInvoices': { requires: ['get_paid.invoices.view'] },
    'Query.refund': { requires: ['get_paid.invoices.view'] },
    'Query.refundFundingSource': {
        requires: ['get_paid.invoices.refund_payments'],
    },
    'Query.refunds': { requires: ['get_paid.invoices.view'] },
    'Query.reminderRules': { ungated: 'no-catalog-key' },
    'Query.retailCustomer': { requires: ['get_paid.customers.view'] },
    'Query.retailCustomerArAging': { requires: ['get_paid.invoices.view'] },
    'Query.retailCustomers': { requires: ['get_paid.customers.view'] },
    'Query.ssoProviderForEmail': { ungated: 'public' },
    'Query.subscriptionDowngradePreview': {
        requires: ['team_org.billing.see_plan'],
    },
    'Query.subscriptionPayments': { requires: ['team_org.billing.see_plan'] },
    'Query.subscriptionUpgradePreview': {
        requires: ['team_org.billing.see_plan'],
    },
    'Query.supportMessenger': { ungated: 'signed-in' },
    'Query.tagsForOrg': { ungated: 'no-catalog-key', silent: true },
    'Query.unapprovedAccounts': { ungated: 'staff' },
    'Query.unsyncedAccountingTransactions': {
        requires: ['integrations.accounting.see_failed_syncs'],
    },
    'Query.uploadUrl': { ungated: 'capability' },
    'Query.user': { ungated: 'signed-in' },
    'Query.vendor': { requires: ['bill_pay.vendors.view'] },
    'Query.vendorPayout': { requires: ['bill_pay.bills.view'] },
    'Query.vendorPayouts': { requires: ['bill_pay.bills.view'] },
    'Query.vendors': { requires: ['bill_pay.vendors.view'] },
    'Query.viewUrl': { ungated: 'staff' },
    'Query.webhooks': { requires: ['developers.api.manage_webhooks'] },
    'Query.workspaceRoles': { ungated: 'no-catalog-key' },
    'Query.youtubePlaylistVideos': { ungated: 'public' },
    'Mutation.acceptChargeback': {
        requires: ['transactions.chargebacks.accept'],
    },
    'Mutation.activateNickelBalanceCard': { requires: ['banking.cards.issue'] },
    'Mutation.addActivityNote': {
        requires: ['transactions.activity.add_notes'],
    },
    'Mutation.addAdminNote': { ungated: 'staff' },
    'Mutation.addBill': { requires: ['bill_pay.bills.create'] },
    'Mutation.addBillPayable': {
        requires: ['bill_pay.bills.pay', 'bill_pay.bills.view'],
    },
    'Mutation.addExternalTeammate': {
        requires: ['team_org.team.invite_members'],
    },
    'Mutation.addNewTeammate': { ungated: 'public' },
    'Mutation.addNickelBalanceDebitAllowRule': {
        requires: ['banking.account.withdraw'],
    },
    'Mutation.addPlatformPartnerReturnUrl': { ungated: 'staff' },
    'Mutation.addPlatformPartnerWebhook': { ungated: 'staff' },
    'Mutation.addQuestionForm': {
        requires: ['get_paid.invoices.create'],
        argumentRequires: {
            achEnabled: ['get_paid.invoices.manage_payment_methods_and_fees'],
            creditCardEnabled: [
                'get_paid.invoices.manage_payment_methods_and_fees',
            ],
            feePassthroughPercent: [
                'get_paid.invoices.manage_payment_methods_and_fees',
            ],
        },
    },
    'Mutation.addRetailCustomer': { requires: ['get_paid.customers.add'] },
    'Mutation.addSubscription': { requires: ['team_org.billing.manage_plan'] },
    'Mutation.addVendor': { requires: ['bill_pay.vendors.add'] },
    'Mutation.adminSendPennyReply': { ungated: 'staff' },
    'Mutation.applyInboundBankTransfer': {
        requires: ['get_paid.invoices.edit', 'get_paid.invoices.view'],
    },
    'Mutation.applyNickelBalanceDepositsToInvoices': {
        requires: [
            'banking.account.see_deposits',
            'get_paid.invoices.edit',
            'get_paid.invoices.view',
        ],
    },
    'Mutation.applyTagToEntities': { ungated: 'no-catalog-key' },
    'Mutation.approveMcpAction': { ungated: 'no-catalog-key' },
    'Mutation.approveOAuthAuthorization': { ungated: 'carve-out' },
    'Mutation.archiveApprovalRule': {
        requires: ['approvals.workflows.manage'],
    },
    'Mutation.backfillRemindersForOpenInvoices': {
        requires: ['get_paid.autoreminders.apply_to_existing'],
    },
    'Mutation.batchAutoDebit': {
        requires: [
            'get_paid.customers.charge_saved_payment_methods',
            'get_paid.invoices.view',
        ],
    },
    'Mutation.batchBillPay': {
        requires: ['bill_pay.bills.pay', 'bill_pay.bills.view'],
    },
    'Mutation.batchCreateRetailCustomerACHDebitAuthorizations': {
        requires: ['get_paid.customers.save_payment_methods'],
        argumentRequires: {
            'input.authorizations[].email': ['get_paid.customers.edit'],
        },
    },
    'Mutation.batchRequestCustomerDebitAuthorizations': {
        requires: ['get_paid.customers.send_debit_authorization_requests'],
    },
    'Mutation.batchRequestVendorDeliveryDetails': {
        requires: ['bill_pay.vendors.send_payment_detail_requests'],
    },
    'Mutation.batchSendArAgingReportEmails': {
        requires: [
            'get_paid.invoices.send_aging_reports',
            'get_paid.invoices.view',
        ],
    },
    'Mutation.becomeUser': { ungated: 'legacy-tier' },
    'Mutation.bulkImportBillsFromFile': { requires: ['bill_pay.bills.create'] },
    'Mutation.bulkImportInvoicesFromFile': {
        requires: ['get_paid.invoices.create'],
    },
    'Mutation.bulkImportRetailCustomersFromFile': {
        requires: ['get_paid.customers.add'],
    },
    'Mutation.bulkImportVendorsFromFile': {
        requires: ['bill_pay.vendors.add'],
    },
    'Mutation.cancelBillPayment': {
        requires: ['bill_pay.bills.cancel_payments', 'bill_pay.bills.view'],
    },
    'Mutation.cancelCustomDomainVerification': {
        requires: ['team_org.organization.manage_custom_subdomain'],
    },
    'Mutation.cancelCustomerDebitAuthorizationRequest': {
        requires: ['get_paid.customers.send_debit_authorization_requests'],
    },
    'Mutation.cancelInvoiceApprovalRequest': { ungated: 'no-catalog-key' },
    'Mutation.cancelInvoiceSend': {
        requires: [
            'get_paid.invoices.send_payment_links',
            'get_paid.invoices.view',
        ],
    },
    'Mutation.cancelPennyPlanForDashboard': { ungated: 'no-catalog-key' },
    'Mutation.cancelRetailCustomerDebitAuthorization': { ungated: 'public' },
    'Mutation.cancelScheduledInvoicePayment': {
        requires: [
            'get_paid.invoices.cancel_scheduled_payments',
            'get_paid.invoices.view',
        ],
    },
    'Mutation.cancelScheduledPayment': {
        requires: ['bill_pay.bills.cancel_payments', 'bill_pay.bills.view'],
    },
    'Mutation.cancelScheduledPlanChange': {
        requires: ['team_org.billing.manage_plan'],
    },
    'Mutation.changeApprovalStatus': { ungated: 'no-catalog-key' },
    'Mutation.changePassword': { ungated: 'signed-in' },
    'Mutation.changePasswordKeepingSession': { ungated: 'signed-in' },
    'Mutation.closeNickelBalanceAccount': {
        requires: ['banking.account.close'],
    },
    'Mutation.closeNickelBalanceBankAccount': {
        requires: ['banking.account.close'],
    },
    'Mutation.completeRadarChallenge': { ungated: 'public' },
    'Mutation.completeSsoEmailVerification': { ungated: 'public' },
    'Mutation.confirmPayment': { ungated: 'public' },
    'Mutation.consumeSignInLink': { ungated: 'public' },
    'Mutation.controlPennyComputer': { ungated: 'no-catalog-key' },
    'Mutation.createACHPaymentMethod': { ungated: 'public' },
    'Mutation.createAccountingClient': { ungated: 'no-catalog-key' },
    'Mutation.createApiToken': { requires: ['developers.api.manage_tokens'] },
    'Mutation.createApproval': {
        requires: ['bill_pay.bills.pay', 'bill_pay.bills.view'],
    },
    'Mutation.createCardDetailsToken': {
        requires: ['banking.cards.see_details'],
    },
    'Mutation.createEnterpriseSsoOrganization': {
        requires: ['team_org.security.manage_sso'],
    },
    'Mutation.createMerchantACHPaymentMethod': {
        requires: ['bill_pay.bills.connect_bank_accounts'],
    },
    'Mutation.createMerchantACHPaymentMethodWithPlaid': {
        requires: ['bill_pay.bills.connect_bank_accounts'],
    },
    'Mutation.createMerchantCreditCardPaymentMethod': {
        requires: ['bill_pay.bills.connect_bank_accounts'],
    },
    'Mutation.createNickelBalanceAccount': {
        requires: ['banking.account.apply', 'banking.account.see_balance'],
        argumentRequires: {
            chartOfAccount: ['integrations.accounting.update_chart_of_accounts'],
        },
    },
    'Mutation.createNickelBalanceCard': { requires: ['banking.cards.issue'] },
    'Mutation.createNickelBalanceCheckDeposit': {
        requires: ['banking.account.deposit'],
        argumentRequires: {
            applications: ['get_paid.invoices.edit', 'get_paid.invoices.view'],
        },
    },
    'Mutation.createNickelBalanceDeposit': {
        requires: ['banking.account.deposit'],
    },
    'Mutation.createNickelBalanceInternalTransfer': {
        requires: ['banking.account.withdraw'],
    },
    'Mutation.createNickelBalanceWithdrawal': {
        requires: ['banking.account.withdraw'],
    },
    'Mutation.createPartnerEnrollment': { ungated: 'capability' },
    'Mutation.createPartnerEnrollmentLink': { ungated: 'capability' },
    'Mutation.createPayment': { ungated: 'public' },
    'Mutation.createPayoutMethodWithPlaid': { ungated: 'carve-out' },
    'Mutation.createPlatformPartner': { ungated: 'staff' },
    'Mutation.createRecurringBill': {
        requires: ['bill_pay.bills.pay', 'bill_pay.bills.create'],
    },
    'Mutation.createRecurringInvoice': {
        requires: ['get_paid.invoices.create'],
        argumentRequires: {
            achEnabled: ['get_paid.invoices.manage_payment_methods_and_fees'],
            creditCardEnabled: [
                'get_paid.invoices.manage_payment_methods_and_fees',
            ],
            feePassthroughPercent: [
                'get_paid.invoices.manage_payment_methods_and_fees',
            ],
        },
    },
    'Mutation.createReminderRule': {
        requires: ['get_paid.autoreminders.create'],
    },
    'Mutation.createRetailCustomerACHDebitAuthorization': {
        requires: ['get_paid.customers.save_payment_methods'],
    },
    'Mutation.createRetailCustomerCreditCardDebitAuthorization': {
        requires: ['get_paid.customers.save_payment_methods'],
    },
    'Mutation.createTagForOrg': { ungated: 'no-catalog-key' },
    'Mutation.createWebhook': { requires: ['developers.api.manage_webhooks'] },
    'Mutation.createWorkspaceRole': {
        requires: ['team_org.team.manage_roles'],
    },
    'Mutation.deactivateNickelAccount': {
        requires: ['team_org.organization.deactivate_account'],
    },
    'Mutation.deactivateRecurringBill': {
        requires: ['bill_pay.bills.edit', 'bill_pay.bills.view'],
    },
    'Mutation.deactivateRecurringInvoice': {
        requires: [
            'get_paid.invoices.cancel_recurring_series',
            'get_paid.invoices.view',
        ],
    },
    'Mutation.deattachMerchantPayment': {
        requires: ['bill_pay.bills.disconnect_payment_accounts'],
    },
    'Mutation.deattachPayment': { ungated: 'public' },
    'Mutation.decideInvoiceApprovalRequest': { ungated: 'no-catalog-key' },
    'Mutation.decideMcpActions': { ungated: 'no-catalog-key' },
    'Mutation.decideNickelBalanceInboundDebit': {
        requires: ['banking.account.withdraw'],
    },
    'Mutation.decidePennyProposal': {
        requires: ['get_paid.invoices.refund_payments'],
    },
    'Mutation.declineMcpAction': { ungated: 'no-catalog-key' },
    'Mutation.declinePennyProposal': { ungated: 'no-catalog-key' },
    'Mutation.deleteBill': {
        requires: ['bill_pay.bills.delete', 'bill_pay.bills.view'],
    },
    'Mutation.deleteLegacyWebhook': {
        requires: ['developers.api.manage_webhooks'],
    },
    'Mutation.deleteReferralInvite': {
        requires: ['team_org.team.cancel_referral_invitations'],
    },
    'Mutation.deleteReminderRule': {
        requires: ['get_paid.autoreminders.delete'],
    },
    'Mutation.deleteRetailCustomerPaymentMethod': {
        requires: ['get_paid.customers.save_payment_methods'],
    },
    'Mutation.deleteVendorPayoutMethod': {
        requires: ['bill_pay.vendors.delete_payment_methods'],
    },
    'Mutation.deleteWebhook': { requires: ['developers.api.manage_webhooks'] },
    'Mutation.deleteWorkspaceRole': {
        requires: ['team_org.team.manage_roles'],
    },
    'Mutation.disableNickelBalanceCard': {
        requires: ['banking.cards.disable'],
    },
    'Mutation.disconnectAccountingIntegration': {
        requires: ['integrations.accounting.disconnect'],
    },
    'Mutation.disconnectConnectorConnection': {
        requires: ['penny.connectors.manage_workspace'],
    },
    'Mutation.disconnectEnterpriseSso': {
        requires: ['team_org.security.manage_sso'],
    },
    'Mutation.disconnectSocialSso': { ungated: 'signed-in' },
    'Mutation.editFollowUpQuestions': { ungated: 'staff' },
    'Mutation.enrollSmsTwoFactor': { ungated: 'signed-in' },
    'Mutation.enterClientWorkspace': { ungated: 'no-catalog-key' },
    'Mutation.enterpriseSsoAuthorizationUrl': { ungated: 'public' },
    'Mutation.finishPennyWebVisit': { ungated: 'no-catalog-key' },
    'Mutation.forgotPassword': { ungated: 'public' },
    'Mutation.generateApprovalSummary': { ungated: 'staff' },
    'Mutation.generateAuthorizationRecordPdf': { ungated: 'staff' },
    'Mutation.generateSsoAdminPortalLink': {
        requires: ['team_org.security.manage_sso'],
    },
    'Mutation.getLinkToken': { ungated: 'no-catalog-key' },
    'Mutation.heartbeatPennyWebVisit': { ungated: 'no-catalog-key' },
    'Mutation.inviteExternalTeammate': {
        requires: [
            'team_org.organization.manage_notifications',
            'team_org.team.invite_members',
        ],
    },
    'Mutation.inviteOwner': { requires: ['team_org.team.invite_owner'] },
    'Mutation.issuePlatformPartnerKey': { ungated: 'staff' },
    'Mutation.login': { ungated: 'public' },
    'Mutation.manualAccountingItemSync': {
        requires: ['integrations.accounting.run_manual_syncs'],
    },
    'Mutation.manualAccountingPageSync': {
        requires: ['integrations.accounting.run_manual_syncs'],
    },
    'Mutation.manualAccountingSync': {
        requires: ['integrations.accounting.run_manual_syncs'],
    },
    'Mutation.markPennyWebsitePaymentNotPaid': { ungated: 'no-catalog-key' },
    'Mutation.newPassword': { ungated: 'public' },
    'Mutation.newTeammate': { requires: ['team_org.team.invite_members'] },
    'Mutation.nickelBalanceAchWireInstructionsUrl': {
        requires: ['banking.account.see_deposit_instructions'],
    },
    'Mutation.nickelBalanceBankLetterUrl': {
        requires: ['banking.account.see_deposit_instructions'],
    },
    'Mutation.nickelBalanceStatementDownloadUrl': {
        requires: ['banking.account.see_statements'],
    },
    'Mutation.nickelBalanceTransactionsCsvUrl': {
        requires: ['banking.account.see_balance'],
    },
    'Mutation.nickelBalanceVoidedCheckUrl': {
        requires: ['banking.account.see_deposit_instructions'],
    },
    'Mutation.onboardingCreatePayoutMethod': { ungated: 'no-catalog-key' },
    'Mutation.parseBillDocument': { requires: ['bill_pay.bills.create'] },
    'Mutation.parseCheckDepositImage': {
        requires: ['banking.account.deposit'],
    },
    'Mutation.parseInvoiceDocument': { requires: ['get_paid.invoices.create'] },
    'Mutation.payNickelBalanceInboundCheck': {
        requires: ['banking.account.withdraw'],
    },
    'Mutation.portalGetLinkToken': { ungated: 'public' },
    'Mutation.prepareChargebackEvidenceUpload': {
        requires: ['transactions.chargebacks.respond'],
    },
    'Mutation.prepareCheckDepositUpload': {
        requires: ['banking.account.deposit'],
    },
    'Mutation.prepareFileUpload': { ungated: 'no-catalog-key' },
    'Mutation.preparePaymentRequestCheckout': { ungated: 'public' },
    'Mutation.preparePennyAttachmentUpload': { ungated: 'no-catalog-key' },
    'Mutation.preparePennyVisitCard': { ungated: 'no-catalog-key' },
    'Mutation.preparePennyWebVisitCapture': { ungated: 'no-catalog-key' },
    'Mutation.processUnsyncedTransactions': {
        requires: ['integrations.accounting.retry_failed_syncs'],
    },
    'Mutation.provisionAccount': { ungated: 'staff' },
    'Mutation.quickbooksTokenCreate': {
        requires: ['integrations.accounting.connect_qbo'],
    },
    'Mutation.reactivateSubscription': {
        requires: ['team_org.billing.manage_plan'],
    },
    'Mutation.recordExternalBillPayment': {
        requires: ['bill_pay.bills.edit', 'bill_pay.bills.view'],
    },
    'Mutation.recordExternalInvoicePayment': {
        requires: ['get_paid.invoices.edit', 'get_paid.invoices.view'],
    },
    'Mutation.recordInvoiceDebitMemo': {
        requires: ['get_paid.invoices.edit', 'get_paid.invoices.view'],
    },
    'Mutation.recordNickelBankingApplicationOpened': {
        requires: ['banking.account.apply'],
    },
    'Mutation.recordOnboardingApplicationEvent': { ungated: 'no-catalog-key' },
    'Mutation.recordPaymentRequestView': { ungated: 'public' },
    'Mutation.recordPennyVisitPaymentOutcome': { ungated: 'no-catalog-key' },
    'Mutation.recordUnderwritingFollowUpCall': { ungated: 'staff' },
    'Mutation.redeemMcpActionApproval': { ungated: 'no-catalog-key' },
    'Mutation.refundPayment': {
        requires: ['get_paid.invoices.refund_payments', 'get_paid.invoices.view'],
    },
    'Mutation.removeDocumentFromQuestionForm': {
        requires: ['get_paid.invoices.edit', 'get_paid.invoices.view'],
    },
    'Mutation.removeInvite': { requires: ['team_org.team.cancel_invitations'] },
    'Mutation.removePlatformPartnerReturnUrl': { ungated: 'staff' },
    'Mutation.removePlatformPartnerWebhook': { ungated: 'staff' },
    'Mutation.removeQuestionForm': {
        requires: ['get_paid.invoices.delete', 'get_paid.invoices.view'],
    },
    'Mutation.removeRetailCustomer': {
        requires: ['get_paid.customers.delete'],
    },
    'Mutation.removeSubscription': {
        requires: ['team_org.billing.manage_plan'],
    },
    'Mutation.removeTagFromOrg': { ungated: 'no-catalog-key' },
    'Mutation.removeTeammate': { requires: ['team_org.team.delete_members'] },
    'Mutation.removeVendor': { requires: ['bill_pay.vendors.delete'] },
    'Mutation.reorderTagsForOrg': { ungated: 'no-catalog-key' },
    'Mutation.requestAlloyApplication': { ungated: 'staff' },
    'Mutation.requestCustomerDebitAuthorization': {
        requires: ['get_paid.customers.send_debit_authorization_requests'],
    },
    'Mutation.requestFollowUpCall': { ungated: 'no-catalog-key' },
    'Mutation.requestMcpActionApproval': { ungated: 'no-catalog-key' },
    'Mutation.requestPennyVisitPaymentApproval': { ungated: 'no-catalog-key' },
    'Mutation.requestSignInLink': { ungated: 'signed-in' },
    'Mutation.requestVendorDeliveryDetails': {
        requires: ['bill_pay.vendors.send_payment_detail_requests'],
        argumentRequires: {
            skipEmail: [
                'bill_pay.vendors.manage_payment_accounts',
                'bill_pay.vendors.edit_check_addresses',
                'bill_pay.vendors.edit_international_wire_info',
            ],
        },
    },
    'Mutation.resendRadarChallenge': { ungated: 'public' },
    'Mutation.resendSsoVerificationCode': { ungated: 'public' },
    'Mutation.returnInboundBankTransfer': {
        requires: ['get_paid.invoices.refund_payments'],
    },
    'Mutation.returnNickelBalanceInboundCheck': {
        requires: ['banking.account.withdraw'],
    },
    'Mutation.revertToAccountingAccount': { ungated: 'signed-in' },
    'Mutation.reviewChargebackSubmission': { ungated: 'staff' },
    'Mutation.revokeApiToken': { requires: ['developers.api.manage_tokens'] },
    'Mutation.revokeNickelBalanceDebitAllowRule': {
        requires: ['banking.account.withdraw'],
    },
    'Mutation.revokePlatformPartnerKey': { ungated: 'staff' },
    'Mutation.revokeSessions': { ungated: 'staff' },
    'Mutation.saveApprovalRule': {
        requires: ['approvals.workflows.manage'],
        argumentRequires: {
            'rule.excludeRequestor': ['approvals.workflows.disallow_self_approval'],
        },
    },
    'Mutation.scheduleInvoiceSend': {
        requires: [
            'get_paid.invoices.send_payment_links',
            'get_paid.invoices.view',
        ],
    },
    'Mutation.scheduleSubscriptionDowngrade': {
        requires: ['team_org.billing.manage_plan'],
    },
    'Mutation.selectPayoutMethod': {
        requires: ['team_org.organization.update_payout_account'],
    },
    'Mutation.sendArAgingReportEmail': {
        requires: [
            'get_paid.invoices.send_aging_reports',
            'get_paid.invoices.view',
        ],
    },
    'Mutation.sendNickelVerificationCodeViaEmail': { ungated: 'public' },
    'Mutation.sendPaymentLinkToRecipients': {
        requires: [
            'get_paid.invoices.send_payment_links',
            'get_paid.invoices.view',
        ],
    },
    'Mutation.sendPennyMessage': { ungated: 'no-catalog-key' },
    'Mutation.sendPlatformPartnerTestEvent': { ungated: 'staff' },
    'Mutation.sendReferralInvite': {
        requires: ['team_org.team.send_referrals'],
    },
    'Mutation.sendRegistrationCode': { ungated: 'public' },
    'Mutation.sendSmsTwoFactorEnrollmentCode': { ungated: 'signed-in' },
    'Mutation.sendTestReminder': { ungated: 'no-catalog-key' },
    'Mutation.sendTwoFactorVerificationCodeViaSMS': { ungated: 'signed-in' },
    'Mutation.setAccountantAccess': { ungated: 'carve-out' },
    'Mutation.setClientAccessMode': {
        requires: ['team_org.team.manage_roles'],
    },
    'Mutation.setCustomDomain': {
        requires: ['team_org.organization.manage_custom_subdomain'],
    },
    'Mutation.setDefaultBillPaymentMethod': {
        requires: ['bill_pay.bills.connect_bank_accounts'],
    },
    'Mutation.setNickelBalanceAccountBillPay': {
        requires: ['banking.account.withdraw'],
    },
    'Mutation.setNickelBalanceAccountChartOfAccount': {
        requires: [
            'banking.account.see_balance',
            'integrations.accounting.update_chart_of_accounts',
        ],
    },
    'Mutation.setNickelBalanceAccountCheckWriting': {
        requires: ['banking.account.withdraw'],
    },
    'Mutation.setNickelBalanceAccountDebitProtection': {
        requires: ['banking.account.withdraw'],
    },
    'Mutation.setNickelBalanceInterestRate': { ungated: 'staff' },
    'Mutation.setOrganizationAccountant': { ungated: 'staff' },
    'Mutation.setOrganizationPlaidUpdated': { ungated: 'no-catalog-key' },
    'Mutation.setPayoutMethodWireAccountDetails': {
        requires: ['banking.account.withdraw'],
    },
    'Mutation.setPayoutMethodWireBeneficiaryName': {
        requires: ['banking.account.withdraw'],
    },
    'Mutation.setPlatformPartnerEnrollmentsPaused': { ungated: 'staff' },
    'Mutation.setPlatformPartnerSuspended': { ungated: 'staff' },
    'Mutation.setQuestionFormRemindersDisabled': {
        requires: [
            'get_paid.autoreminders.disable_per_invoice',
            'get_paid.invoices.view',
        ],
    },
    'Mutation.setTagOnEntity': { ungated: 'no-catalog-key' },
    'Mutation.setTwoFactorMethodEnabled': { ungated: 'signed-in' },
    'Mutation.signUpThroughPartnerEnrollment': { ungated: 'capability' },
    'Mutation.signup': { ungated: 'public' },
    'Mutation.simulateBankTransferCredit': { ungated: 'public' },
    'Mutation.ssoAuthorizationUrl': { ungated: 'public' },
    'Mutation.ssoSignup': { ungated: 'public' },
    'Mutation.ssoTwoFactorChallenge': { ungated: 'public' },
    'Mutation.startFollowUpVoiceCall': { ungated: 'staff' },
    'Mutation.startPartnerEnrollmentSession': { ungated: 'capability' },
    'Mutation.startPennyWebVisit': { ungated: 'no-catalog-key' },
    'Mutation.startWorkspaceConnectorConnection': {
        requires: ['penny.connectors.manage_workspace'],
    },
    'Mutation.stopCheckPayment': {
        requires: ['bill_pay.bills.stop_checks', 'bill_pay.bills.view'],
    },
    'Mutation.submitChargebackResponse': {
        requires: ['transactions.chargebacks.respond'],
    },
    'Mutation.submitNickelBalanceApplication': {
        requires: ['banking.account.apply', 'banking.account.see_balance'],
    },
    'Mutation.submitNickelUserFeedback': { ungated: 'no-catalog-key' },
    'Mutation.syncAccountingCustomers': {
        requires: ['integrations.accounting.run_manual_syncs'],
    },
    'Mutation.togglePaymentState': {
        requires: ['get_paid.invoices.edit', 'get_paid.invoices.view'],
    },
    'Mutation.unlinkOrganizationFromAccountant': { ungated: 'carve-out' },
    'Mutation.updateAnswerForm': { ungated: 'capability' },
    'Mutation.updateBankAccount': {
        requires: ['team_org.organization.update_payout_account'],
    },
    'Mutation.updateBill': {
        requires: ['bill_pay.bills.edit', 'bill_pay.bills.view'],
    },
    'Mutation.updateBillExpenseChartOfAccount': {
        requires: ['integrations.accounting.update_chart_of_accounts'],
    },
    'Mutation.updateBranding': {
        requires: ['team_org.organization.manage_branding'],
    },
    'Mutation.updateClientAccess': { requires: ['team_org.team.manage_roles'] },
    'Mutation.updateFeeChartOfAccount': {
        requires: ['integrations.accounting.update_chart_of_accounts'],
    },
    'Mutation.updateInvoiceSalesChartOfAccount': {
        requires: ['integrations.accounting.update_chart_of_accounts'],
    },
    'Mutation.updateMerchantPaymentMethod': { ungated: 'no-catalog-key' },
    'Mutation.updateMyNotifications': { ungated: 'signed-in' },
    'Mutation.updateNickelBalanceAccount': {
        requires: ['banking.account.apply', 'banking.account.see_balance'],
    },
    'Mutation.updateNickelBalanceCard': { requires: ['banking.cards.issue'] },
    'Mutation.updateNotificationDefaults': {
        requires: ['team_org.organization.manage_notifications'],
    },
    'Mutation.updateNotificationSettings': {
        requires: ['team_org.organization.manage_notifications'],
    },
    'Mutation.updateOnboardingInformation': {
        ungated: 'carve-out',
        argumentRequires: {
            'onboardingInfo.showGetStarted': [
                'team_org.organization.dismiss_get_started',
            ],
        },
    },
    'Mutation.updateOrCreateChartOfAccount': {
        requires: ['integrations.accounting.update_chart_of_accounts'],
    },
    'Mutation.updateOrganizationAdminControls': { ungated: 'staff' },
    'Mutation.updateOrganizationStatus': { ungated: 'staff' },
    'Mutation.updatePartnerEnrollment': { ungated: 'capability' },
    'Mutation.updatePayment': { ungated: 'public' },
    'Mutation.updatePaymentSettings': {
        ungated: 'carve-out',
        argumentRequires: {
            achEnabled: ['get_paid.invoices.manage_payment_methods_and_fees'],
            creditCardEnabled: [
                'get_paid.invoices.manage_payment_methods_and_fees',
            ],
            feePassthroughPercent: [
                'get_paid.invoices.manage_payment_methods_and_fees',
            ],
            paymentAmountEditable: [
                'get_paid.invoices.manage_payment_methods_and_fees',
            ],
            showOtherUnpaidInvoices: [
                'get_paid.invoices.manage_payment_methods_and_fees',
            ],
            invoiceMemoTemplate: ['get_paid.invoices.edit'],
            automaticQbInvoiceEmail: ['get_paid.invoices.send_payment_links'],
        },
    },
    'Mutation.updatePlaidIdentityVerificationId': { ungated: 'signed-in' },
    'Mutation.updateQuestionForm': {
        requires: ['get_paid.invoices.edit', 'get_paid.invoices.view'],
        argumentRequires: {
            achEnabled: ['get_paid.invoices.manage_payment_methods_and_fees'],
            creditCardEnabled: [
                'get_paid.invoices.manage_payment_methods_and_fees',
            ],
            feePassthroughPercent: [
                'get_paid.invoices.manage_payment_methods_and_fees',
            ],
        },
    },
    'Mutation.updateRecurringInvoice': {
        requires: ['get_paid.invoices.edit', 'get_paid.invoices.view'],
    },
    'Mutation.updateReminderRule': {
        requires: ['get_paid.autoreminders.edit'],
    },
    'Mutation.updateRetailCustomer': { requires: ['get_paid.customers.edit'] },
    'Mutation.updateRetailCustomerPaymentMethod': { ungated: 'public' },
    'Mutation.updateSubdomain': {
        requires: ['team_org.organization.update_subdomain'],
    },
    'Mutation.updateSubscriptionPaymentMethod': {
        requires: ['team_org.billing.manage_plan'],
    },
    'Mutation.updateTagForOrg': { ungated: 'no-catalog-key' },
    'Mutation.updateTeamNotifications': {
        requires: ['team_org.organization.manage_notifications'],
    },
    'Mutation.updateTeammate': { requires: ['team_org.team.change_roles'] },
    'Mutation.updateTeammateProfile': {
        requires: ['team_org.team.edit_members'],
    },
    'Mutation.updateUnappliedPaymentChartOfAccount': {
        requires: ['integrations.accounting.update_chart_of_accounts'],
    },
    'Mutation.updateVendor': { requires: ['bill_pay.vendors.edit'] },
    'Mutation.updateVendorACHDeliveryMethodWithPlaid': {
        ungated: 'capability',
    },
    'Mutation.updateVendorCheckPayoutMethod': {
        requires: ['bill_pay.vendors.edit_check_addresses'],
    },
    'Mutation.updateVendorDomesticWirePayoutMethod': {
        requires: ['bill_pay.vendors.manage_payment_accounts'],
    },
    'Mutation.updateVendorPayoutMethod': {
        requires: ['bill_pay.vendors.manage_payment_accounts'],
    },
    'Mutation.updateVendorWirePayoutMethod': {
        requires: ['bill_pay.vendors.edit_international_wire_info'],
    },
    'Mutation.updateWorkspaceRole': {
        requires: ['team_org.team.manage_roles'],
    },
    'Mutation.uploadOrganizationRFIDocuments': {
        requires: ['team_org.organization.upload_compliance_documents'],
    },
    'Mutation.validateEmailVerificationCode': { ungated: 'public' },
    'Mutation.verifyTwoFactorSMSAuthCode': { ungated: 'public' },
    'Mutation.voidExternalBillPayment': {
        requires: ['bill_pay.bills.edit', 'bill_pay.bills.view'],
    },
    'Mutation.voidExternalInvoicePayment': {
        requires: ['get_paid.invoices.edit', 'get_paid.invoices.view'],
    },
    'Mutation.voidInvoiceDebitMemo': {
        requires: ['get_paid.invoices.edit', 'get_paid.invoices.view'],
    },
    'Mutation.xeroConnectionComplete': {
        requires: ['integrations.accounting.connect_qbo'],
    },
    'Mutation.xeroConnectionReconnect': {
        requires: ['integrations.accounting.connect_qbo'],
    },
    'Mutation.xeroConnectionStart': {
        requires: ['integrations.accounting.connect_qbo'],
    },
};
//# sourceMappingURL=operationAuthz.generated.js.map